
<script>
import http from '@/service/http'
import findIndex from 'lodash/findIndex'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'Pagamento',
  data () {
    return {
      list: [],
      busca: '',
      pagination: {
        current_page: 1,
        last_page: 1
      }
    }
  },
  mounted () {
    this.paginate()
  },
  methods: {
    async paginate (page) {
      if (page) {
        this.pagination.current_page = page
      }
      const { data } = await http.get(`/orcamentos/pagamentos?page=${this.pagination.current_page}&busca=${this.busca}`)
      if (data != null) {
        this.list = data.data
        this.pagination.current_page = data.current_page
        this.pagination.last_page = data.last_page
      }
    },
    async buscar ($page) {
      const { data } = await http.get(`/orcamentos/pagamentos?&busca=${this.busca}`)
      if (data != null) {
        this.list = data.data
        this.pagination.current_page = data.current_page
        this.pagination.last_page = data.last_page
      }
    },
    checkListTotal () {
      if (this.list.length === 0) {
        this.pagination.current_page = 1
        this.busca = ''
        this.paginate()
      }
    },
    async updateList (obj) {
      const { pagamento } = obj
      const index = await findIndex(this.list, { id: pagamento.id })
      if (index > -1) {
        this.list[index] = { ...pagamento }
      } else {
        this.list.unshift(pagamento)
      }
      window.Materialize.toast('Registro salvo com sucesso!!', 4000)
    },
    destroy (pagamento) {
      this.$swal({
        title: `Deseja remover ${pagamento.pagamento}?`,
        html: 'Esta operação é irreversível',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sim, quero excluir!',
        reverseButtons: true
      }).then(async () => {
        const { data } = await http.delete(`/orcamentos/pagamentos/${pagamento.id}`)
        if (data != null) {
          const index = await findIndex(this.list, { id: pagamento.id })
          if (index > -1) {
            this.list.splice(index, 1)
            window.Materialize.toast('Registro removido com sucesso!!', 4000)
            this.checkListTotal()
          }
        }
      })
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapGetters(['permissoes']),
    showBtNovo () {
      return this.$route.name === 'orcamentos-pagamentos.index'
    },
    showBtVoltar () {
      return this.$route.name === 'orcamentos-pagamentos.form'
    },
    hasItens () {
      return this.list.length > 0
    }
  }
}
</script>

<template>
	<div>

    <div class="content">

      <div class="row">
        <div class="col s12 m7">
          <h5>Orçamentos :: Condições de Pagamento</h5>
        </div>
        <div class="input-field col s9 m4">
          <form @submit.prevent="buscar" v-show="showBtNovo">
            <input id="busca" type="text" v-model="busca">
            <label for="busca">Buscar</label>
          </form>        
        </div>
        <div class="col s3 m1 input-field right-align">
          <router-link :to="{ name: 'orcamentos-pagamentos.form' }" v-show="showBtNovo && permissoes.indexOf('orcamento-pagamento.inserir') > -1" class="btn-floating btn-large waves-effect waves-light"><i class="material-icons">add</i></router-link>
          <router-link :to="{ name: 'orcamentos-pagamentos.index' }" v-show="showBtVoltar" class="btn-floating btn-large waves-effect waves-light red"><i class="material-icons">close</i></router-link>
        </div>
      </div>

      <div class="row">
        <div class="col s12">
          <router-view @update-orcamentos-pagamentos-list="updateList"></router-view>
        </div>
      </div>

      <div class="center-align" v-show="showBtNovo && !hasItens && !loading">
        <p>Nenhum registro encontrado!</p>
      </div>

      <div class="row z-depth-1" v-show="showBtNovo && hasItens">
        <div class="col s12">
          <table class="responsive-table bordered highlight">
            <thead>
              <tr>
                <th>Condição de Pagamento</th>
                <th></th>
                <th class="right-align">Ações</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="pagamento in list">
                <td>
                  <router-link :to="{ name: 'orcamentos-pagamentos.form', params: { id: pagamento.id } }" v-if="permissoes.indexOf('orcamento-pagamento.editar') > -1">{{ pagamento.pagamento }}</router-link>
                  <span v-else>{{ pagamento.pagamento }}</span>
                </td>
                <td class="right-align">
                  <span class="new badge red" v-if="!pagamento.ativo" data-badge-caption="inativo"></span>
                </td>
                <td class="right-align">
                  <router-link :to="{ name: 'orcamentos-pagamentos.form', params: { id: pagamento.id } }" v-show="permissoes.indexOf('orcamento-pagamento.editar') > -1"><i class="material-icons blue-text">edit</i></router-link>
                  <a href="#" @click.prevent="destroy(pagamento)" v-show="permissoes.indexOf('orcamento-pagamento.excluir') > -1">
                    <i class="material-icons red-text">delete_forever</i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row" v-show="showBtNovo && hasItens">
        <div class="col s12 center-align">
          <paginate
          :page-count='pagination.last_page'
          :click-handler="paginate"
          :prev-text="'chevron_left'"
          :next-text="'chevron_right'"
          :container-class="'pagination'"
          :page-class="'waves-effect'"
          :prev-class="'material-icons'"
          :next-class="'material-icons'"
          :force-page='pagination.current_page-1'
          >
        </paginate>
      </div>
    </div>

  </div>
</div>
</template>



// WEBPACK FOOTER //
// src/features/orcamentos/pagamentos/index.vue